module.exports = __webpack_public_path__ + "35f35c9d122980c8c5e76f81e5c3c5f2.gif";